"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLazyImageSlots = exports.default = exports.LazyImage = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _SuspenseImage = _interopRequireDefault(require("../SuspenseImage"));
var _useIntersectionObserver = _interopRequireDefault(require("../useIntersectionObserver"));
var _lazyImageClasses = require("./lazyImageClasses");
var _jsxRuntime = require("react/jsx-runtime");
const getLazyImageSlots = _ => ({
  root: ['root'],
  skeleton: ['skeleton'],
  image: ['image']
});
exports.getLazyImageSlots = getLazyImageSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getLazyImageSlots(ownerState);
  const composedClasses = (0, _base.unstable_composeClasses)(slots, _lazyImageClasses.getLazyImageUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const LazyImageRoot = (0, _material.styled)('span', {
  name: 'MuiOriLazyImage',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root]
})(({
  ownerState: {
    width,
    height
  }
}) => ({
  display: 'inline-block',
  height,
  width
}));
const LazyImageSkeleton = (0, _material.styled)(_material.Skeleton, {
  name: 'MuiOriLazyImage',
  slot: 'Skeleton',
  overridesResolver: (_, styles) => [styles.skeleton]
})({
  display: 'inline-block',
  height: '100%',
  width: '100%'
});
const LazyImageImg = (0, _material.styled)('img', {
  name: 'MuiOriLazyImage',
  slot: 'Image',
  overridesResolver: (_, styles) => [styles.image]
})({
  display: 'inline-block',
  height: '100%',
  width: '100%'
});
const InnerSuspendedImage = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    loading,
    didIntersect,
    classes,
    src,
    srcSet,
    imgProps,
    SuspenseImageProps,
    errorFallback,
    alt
  } = props;
  const imageProps = {
    errorFallback,
    alt
  };
  if (loading === 'eager' || didIntersect) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(LazyImageImg, {
      as: _SuspenseImage.default,
      ...imageProps,
      ref: ref,
      className: classes?.image,
      src: src,
      srcSet: srcSet,
      ...imgProps,
      ...SuspenseImageProps
    });
  }

  // Do not mount suspended image
  return null;
});
const InnerLazyImage = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    loading,
    didIntersect,
    errorFallback,
    classes,
    fallback = /*#__PURE__*/(0, _jsxRuntime.jsx)(LazyImageSkeleton, {
      animation: "wave",
      className: classes?.skeleton,
      variant: "rectangular"
    }),
    src,
    srcSet,
    imgProps,
    alt
  } = props;
  const imageProps = {
    alt
  };
  const [isLoaded, setIsLoaded] = (0, _react.useState)(loading === 'eager');
  const [error, setError] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    if (loading === 'eager' || loading === 'lazy' && !didIntersect) {
      return () => {};
    }
    const onLoad = () => setIsLoaded(true);
    const onError = event => setError(event);
    const image = new Image();
    image.addEventListener('load', onLoad);
    image.addEventListener('error', onError);
    if (srcSet) {
      image.srcset = srcSet;
    }
    image.src = src;
    image.alt = alt ?? '';
    return () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    };
  }, [loading, didIntersect, src, srcSet, alt]);
  if (isLoaded) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(LazyImageImg, {
      ...imageProps,
      ref: ref,
      src: src,
      srcSet: srcSet,
      className: classes?.image,
      ...imgProps
    });
  }
  if (error !== undefined) {
    return errorFallback;
  }
  return fallback;
});
const LazyImage = exports.LazyImage = /*#__PURE__*/(0, _react.forwardRef)((inProps, inRef) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriLazyImage'
  });
  const wrapperRef = (0, _react.useRef)();
  const ref = (0, _material.useForkRef)(inRef, wrapperRef);
  const {
    className,
    sx,
    component,
    loading = 'lazy',
    shouldThrowError = false,
    enableSuspense = false,
    errorFallback = null,
    fallback,
    imgRef,
    width,
    height,
    src,
    srcSet,
    SuspenseImageProps,
    imgProps,
    ...otherProps
  } = props;
  const {
    didIntersect
  } = (0, _useIntersectionObserver.default)({
    ref: wrapperRef,
    disabled: loading === 'eager',
    unmountAfterIntersection: true
  });
  const ownerState = {
    ...props,
    SuspenseImageProps,
    imgProps,
    src,
    srcSet,
    width,
    height,
    loading,
    shouldThrowError,
    errorFallback,
    didIntersect
  };
  const classes = useUtilityClasses(ownerState);
  const InnerComponent = enableSuspense ? InnerSuspendedImage : InnerLazyImage;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(LazyImageRoot, {
    ref: ref,
    ownerState: ownerState,
    sx: sx,
    as: component,
    className: (0, _clsx.default)(classes.root, className),
    ...otherProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(InnerComponent, {
      ...ownerState,
      ref: imgRef,
      classes: classes
    })
  });
});
var _default = exports.default = LazyImage;
